
export const MessageTypes = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
  API_ERRORS: 'API_ERRORS',
};
